import React from "react";
import {
  TextInput,
  SelectInput,
  Filter,
  ReferenceInput,
  RefreshButton
} from "admin-on-rest";
import {
  red700,
  blue700,
  lightBlue700,
  teal700,
  grey300,
  green700,
  lightGreen700,
  orange800,
  blueGrey700,
  grey700
} from "material-ui/styles/colors";
import { CardActions } from "material-ui/Card";
import Chip from "material-ui/Chip";
import { styles } from "./styles";

export const OrdersFilter = ({ ...props }) => (
  <Filter {...props}>
    {permissions => [
      <TextInput
        label="resources.orders.actions.search"
        source="search"
        alwaysOn
      />,
      <SelectInput
        label="resources.orders.fieldList.status"
        defaultValue="paid"
        source="status"
        choices={[
          { id: "paid", name: "Paid" },
          { id: "invoiced", name: "Invoiced" },
          { id: "completed", name: "Completed" },
          { id: "cancelled", name: "Cancelled" },
          { id: "delivered", name: "Delivered" },
          { id: "expired", name: "Expired" },
          { id: "pending payment", name: "Pending Payment" },
          { id: "preparing", name: "Preparing" },
          { id: "out for delivery", name: "Out for Delivery" },
          { id: "rejected", name: "Rejected" }
        ]}
      />,
      permissions === "Admin" ? (
        <ReferenceInput
          label="resources.orders.fieldList.account"
          source="account_id"
          reference="accounts"
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      ) : null,
      <ReferenceInput
        label="resources.orders.fieldList.marketer"
        source="marketer_id"
        reference="marketers"
      >
        <SelectInput optionText="nickname" />
      </ReferenceInput>
    ]}
  </Filter>
);

export const OrdersActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter,
  refresh
}) => (
  <CardActions style={styles.cardActionStyleSmall} className="orders-actions">
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);
export const FullNameField = ({ record = {} }) => (
  <span>
    {record.customer_info.first_name} {record.customer_info.last_name}
  </span>
);
FullNameField.defaultProps = { label: "Customer" };

export const StatusField = ({ record = {} }) => {
  let colorBg = grey700;
  if (record.status === "paid") {
    colorBg = red700;
  } else if (record.status === "invoiced") {
    colorBg = teal700;
  } else if (record.status === "delivered") {
    colorBg = lightGreen700;
  } else if (record.status === "expired") {
    colorBg = grey300;
  } else if (record.status === "pending payment") {
    colorBg = orange800;
  } else if (record.status === "preparing") {
    colorBg = lightBlue700;
  } else if (record.status === "out for delivery") {
    colorBg = blue700;
  } else if (record.status === "completed") {
    colorBg = green700;
  } else if (record.status === "cancelled") {
    colorBg = grey300;
  } else if (record.status === "rejected") {
    colorBg = blueGrey700;
  }

  return (
    <Chip backgroundColor={colorBg} labelColor={"#FFFFFF"} style={styles.chip}>
      <span>{record.status}</span>
    </Chip>
  );
};



// WEBPACK FOOTER //
// ./src/orders/OrderValues.js